import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { ImpersonateDialogComponent } from './impersonate-dialog/impersonate-dialog.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { PopupModule } from 'shared/popup-service/popup.module';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';
import { GdprPrivacyModule } from 'shared/gdpr-privacy/gdpr-privacy.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { SearchWithAutocompleteModule } from 'shared/search-with-autocomplete/search-with-autocomplete.module';
import { MultiselectAutocompleteModule } from 'shared/multiselect-autocomplete/multiselect-autocomplete.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { CookieDialogComponent } from './cookie-dialog/cookie-dialog.component';

@NgModule({
    declarations: [ProfileComponent, ImpersonateDialogComponent, CookieDialogComponent],
    imports: [
        CommonModule,
        TranslateModule,
        MatIconModule,
        MatMenuModule,
        PopupModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        CustomerPrivacyModule,
        GdprPrivacyModule,
        SearchWithAutocompleteModule,
        MultiselectAutocompleteModule,
        MatExpansionModule,
        MatSlideToggleModule,
    ],
    exports: [ProfileComponent, ImpersonateDialogComponent],
})
export class ProfileModule {}
